import {Component, ElementRef, Input, OnInit, AfterViewInit, ViewChild} from '@angular/core';
import {HotelSummary} from '../models/hotel-summary.model';
import {CHAT_CONSTANTS} from '../utils/app.constants';

@Component({
  selector: 'app-chat-hotel-slider',
  templateUrl: './chat-hotel-slider.component.html',
  styleUrls: ['./chat-hotel-slider.component.scss']
})
export class ChatHotelSliderComponent implements OnInit, AfterViewInit {
  @Input() content!: HotelSummary[];
  @ViewChild('sliderFrame') sliderFrame!: ElementRef<HTMLDivElement>;
  cardWidth = 0;
  readonly SLIDER_DIRECTIONS = CHAT_CONSTANTS.SLIDER.DIRECTION;

  constructor() {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const firstCard = this.sliderFrame?.nativeElement.querySelector('.surf-option-slider__item') as HTMLElement;
    if (firstCard) {
      this.cardWidth = firstCard.offsetWidth + (parseInt(getComputedStyle(firstCard).marginRight, 10) || 0);
    }
  }

  slide(direction: string) {
    if (!this.sliderFrame) {
      return;
    }

    const frame = this.sliderFrame.nativeElement;
    const scrollAmount = this.cardWidth || CHAT_CONSTANTS.SLIDER.DEFAULT_SCROLL;

    if (direction === this.SLIDER_DIRECTIONS.LEFT) {
      frame.scrollTo({left: frame.scrollLeft - scrollAmount, behavior: 'smooth'});
    } else if (direction === this.SLIDER_DIRECTIONS.RIGHT) {
      frame.scrollTo({left: frame.scrollLeft + scrollAmount, behavior: 'smooth'});
    }
  }
}
